import { useState, useEffect } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import TextAnimP1 from "./TextAnimP1";

const slides = [
  {
    text: `Working with this team completely changed the way we look at branding. They took the time to understand our business, audience, and values — and built a brand strategy that feels truly 'us.' Our new identity not only looks stunning but has helped us attract better clients and stand out in a crowded market.`,
    name: "Lucas Fernández",
    role: "Marketing Head, UrbanNest Interiors",
  },
  {
    text: `We had a very basic, outdated website before. Their team delivered a site that is fast, visually beautiful, and designed to convert visitors into leads. Within the first month of launch, our inquiries went up by 40%, and our customers have been complimenting the user experience.`,
    name: "Aisha Patel",
    role: "Co-Founder, FreshBite Foods",
  },
  {
    text: `The digital ads campaign they ran for us was nothing short of impressive. Instead of just spending our budget, they optimized every step — from targeting to creatives to landing pages — and kept us in the loop with clear reports. The ROI has been the highest we've ever seen.`,
    name: "Ethan Nakamura",
    role: "Growth Manager, TechNova Solutions",
  },
  {
    text: `Performance marketing was always a headache for us, until we partnered with them. They approached it with a scientific mindset — A/B testing, data analysis, constant optimizations — and we saw our cost-per-lead drop by nearly 30% in two months. That's a big deal for our sales pipeline.`,
    name: "Sofia Martins",
    role: "VP of Sales, FinEdge Capital",
  },
  {
    text: `Our festive campaign went viral, literally. From concept to execution, they delivered a campaign that was fun, emotional, and share-worthy. Engagement on our social channels skyrocketed and we gained thousands of followers organically.`,
    name: "Ryan Torres",
    role: "Brand Manager, SoulSpice Foods",
  },
  {
    text: `What I loved most was their collaborative approach. They didn't just 'take a brief' — they challenged us, brought fresh ideas to the table, and pushed us to think bigger. The final marketing strategy was far stronger because of their input.`,
    name: "Amira El-Sayed",
    role: "Marketing Director, AxisWellness",
  },
  {
    text: `Our e-commerce business was struggling with low sales despite good traffic. They identified gaps in our funnel, redesigned our ads, improved product pages, and set up retargeting campaigns. Sales have since doubled, and we now have a clear growth roadmap.`,
    name: "Noah Williams",
    role: "Founder, TrendHive Apparel",
  },
  {
    text: `The creative team is a powerhouse. From brand films to social creatives, everything they delivered was on-brand, fresh, and memorable. Our customers loved it — we got so many comments saying how 'cool' our new look was.`,
    name: "Chiara Rossi",
    role: "Head of Marketing, NeoGlam Cosmetics",
  },
  {
    text: `We were launching a new service and had just three weeks to make a splash. They planned and executed a 360° launch campaign — social media, influencers, ads, email marketing — and we hit our first-quarter targets in just 6 weeks.`,
    name: "Omar Haddad",
    role: "Bussiness Development Lead, CarePoint Healthcare",
  },
  {
    text: `Honestly, what sets them apart is their commitment. They don't just deliver a service, they become a part of your team. Their insights, reporting, and constant communication made us feel confident every step of the way.`,
    name: "Mia Johansson",
    role: "COO, GreenSpark Energy",
  },
];

export default function HomeSliderCxFeedback() {
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);

  const nextSlide = () => {
    setFade(false);
    setTimeout(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
      setFade(true);
    }, 200);
  };

  const prevSlide = () => {
    setFade(false);
    setTimeout(() => {
      setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
      setFade(true);
    }, 200);
  };

  const { text, name, role } = slides[current];

  return (
    <TextAnimP1>
      <div className="pointer-events-none dark:text-white flex items-center justify-center xl:px-35 px-10">
        <div className="w-full py-10 relative flex min-h-[45vh] xl:min-h-[50vh] justify-between items-center xl:items-start flex-col xl:flex-row">
          <div
            className={`transition-opacity duration-300 ${
              fade ? "opacity-100" : "opacity-0"
            }`}
          >
            {/* Text */}
            <p className="text-xl sm:text-2xl font-semibold md:max-w-4xl text-center xl:text-left">
              “{text}”
            </p>
            
            {/* Author */}
            <div className="mt-6 text-center xl:text-left">
              <p className="font-semibold">{name}</p>
              <p className="text-gray-400 text-sm">{role}</p>
            </div>
          </div>

          {/* Navigation */}
          <div className="transform flex gap-3">
            <button
              onClick={prevSlide}
              className="bg-transparent p-2 hover:opacity-75 transition pointer-events-auto cursor-pointer hover:text-[#EE005B] "
            >
              <BsArrowLeft size={34} />
            </button>
            <button
              onClick={nextSlide}
              className="bg-transparent p-2 hover:opacity-75 transition pointer-events-auto cursor-pointer hover:text-[#EE005B] "
            >
              <BsArrowRight size={34} />
            </button>
          </div>
        </div>
      </div>
    </TextAnimP1>
  );
}
